module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('createdAt.label'),
      "columns": 6
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "format": "dd/MM/yyyy HH:mm",
      "start-placeholder": "Data Inicial",
      "end-placeholder": "Data Final"
    },
    model: {
      value: (_vm.createdAt),
      callback: function($$v) {
        _vm.createdAt = $$v
      },
      expression: "createdAt"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Código(s) do(s) produto(s)"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.marketplace.codes),
      expression: "filters.marketplace.codes"
    }],
    staticClass: "form-textarea",
    attrs: {
      "rows": "8",
      "placeholder": "99999, 99999, 99999, 99999"
    },
    domProps: {
      "value": (_vm.filters.marketplace.codes)
    },
    on: {
      "change": _vm.removeTrim,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters.marketplace, "codes", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilize vírgula (,) para múltiplos códigos.")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2050709a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/reportOrderStatus/filters/marketplace/Shared.vue
// module id = 2969
// module chunks = 0